import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { isSubmitting } from 'redux-form';
import { Spinner, makeLocationUrl } from 'shared';
import { useLazyGetConsumerApplicationsV2PrequalificationsNewQuery } from 'consumer-applications-v2-api';
import * as actions from '../actions';
import { PracticeSearchForm } from '../forms';
function PracticeSearchInput({ className = '', isSubmitting, setPractice, }) {
    // Hooks
    const history = useHistory();
    const { search } = useLocation();
    const [getConsumerApplicationsV2PrequalificationsNew] = useLazyGetConsumerApplicationsV2PrequalificationsNewQuery();
    // Vars
    const query = new URLSearchParams(search);
    const store_number = query.get('store_number');
    useEffect(() => {
        if (store_number) {
            handleSubmit({ adsStoreNumber: store_number });
        }
    }, [store_number]);
    const handleSubmit = async (item) => {
        if (item && item.locationId) {
            setPractice(item);
            //check prequalifications/new response for proveOptOut
            const res = await getConsumerApplicationsV2PrequalificationsNew({
                locationId: item.locationId,
                termsLanguage: 'en',
            });
            if (res.data) {
                const { proveOptOut } = res.data;
                if (!proveOptOut) {
                    history.push({
                        pathname: '/credit-portal/prove',
                        search: `?store=${item.adsStoreNumber}&locationId=${item.locationId}&ref=psi`,
                        state: {
                            practice: item,
                        },
                    });
                }
                else {
                    history.push({
                        pathname: makeLocationUrl(Number(item.locationId)) + `?ref=psi`,
                        state: {
                            practice: item,
                        },
                    });
                }
            }
        }
        else {
            item && item.preventDefault && item.preventDefault();
            return false;
        }
    };
    return (_jsxs("div", { className: `practice-search-input ${className} `, children: [_jsx(PracticeSearchForm, { displayOptions: {
                    showPrequalify: true,
                    placeholder: 'Practice Name, Address, or Phone Number',
                }, handleSubmit: handleSubmit }), _jsx("div", { className: "mt-5 spinner", children: isSubmitting && _jsx(Spinner, {}) })] }));
}
function mapStateToProps(state) {
    return {
        isSubmitting: isSubmitting('practiceSearchForm')(state),
    };
}
const mapDispatchToProps = {
    setPractice: actions.setPractice,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(PracticeSearchInput);
